import type { DrawStroke } from '../schema';

/**
 * Pure SVG utilities for freehand pen/highlighter strokes — serializable vector
 * data the classroom replays, timed against narration via each stroke's
 * `triggerMs`.
 */

/** Estimate how long a stroke should animate (280–2400ms by polyline length). */
export function approximateStrokeDrawDurationMs(stroke: DrawStroke): number {
  let length = 0;
  const pts = stroke.points;
  for (let i = 1; i < pts.length; i++) {
    const dx = pts[i].x - pts[i - 1].x;
    const dy = pts[i].y - pts[i - 1].y;
    length += Math.hypot(dx, dy);
  }
  return Math.max(280, Math.min(2400, length * 3));
}

/** Convert stroke points to an SVG `points` attribute string. */
export function strokePointsAttr(stroke: DrawStroke): string {
  return stroke.points.map((p) => `${p.x},${p.y}`).join(' ');
}
